import React, { createContext, useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Create the context
const LoadingContext = createContext();

// Provider component
export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false); 
  const location = useLocation();

  useEffect(()=>{
    setLoading(true);
  }, [location.pathname])

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {/* Show the loading screen only if loading is true */}
      {loading && (
        <div className="loading-overlay">
        <div className="spinner"></div>
      </div>
      )}
      {children}
    </LoadingContext.Provider>
  );
};

// Custom hook for easy access
export const useLoading = () => useContext(LoadingContext);
